import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {useExperiments} from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import React from 'react';
import {ProvidedGlobalProps, useGlobals, withGlobalProps} from '../../../providers/globalPropsProvider';
import {RenderContext, useIsRenderedFrom} from '../../../providers/renderContext';
import {SPECS} from '../../../specs';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import s from './StockIndicator.scss';

export const StockIndicatorDataHook = {
  LowStock: 'stock-indicator',
  OutOfStock: 'out-of-stock-indicator',
};

type StockIndicatorComponentProps = ProvidedGlobalProps & IProvidedTranslationProps;

const StockIndicatorComponent: React.FC<StockIndicatorComponentProps> = ({t}) => {
  const {experiments} = useExperiments();
  const {remainingItemCount} = useGlobals();
  const isStickyAddToCartEnabled = experiments.enabled(SPECS.StickyAddToCartMobile);
  const isRenderedFromStickyDrawer = useIsRenderedFrom(RenderContext.StickyDrawer);
  const isStickyDrawer = isStickyAddToCartEnabled && isRenderedFromStickyDrawer;

  if (remainingItemCount > 0) {
    return (
      <ConditionalRender by="productPage_stockIndicator">
        <div
          className={classNames(s.stockIndicator, {[s.stickyDrawer]: isStickyDrawer})}
          data-hook={StockIndicatorDataHook.LowStock}>
          {t('productPage.lowStockMessage.label', {Inventory: remainingItemCount})}
        </div>
      </ConditionalRender>
    );
  }

  if (remainingItemCount === 0) {
    return (
      <div className={s.outOfStockIndicator} data-hook={StockIndicatorDataHook.OutOfStock}>
        {t('PRODUCT_OUT_OF_STOCK_BUTTON')}
      </div>
    );
  }

  return null;
};

export const StockIndicator = withGlobalProps(withTranslations('globals.texts')(StockIndicatorComponent));
